export default __webpack_public_path__ + "static/media/oncology2.c5c30315.jpg";